<script>
    /*  Options by browser type:
            Assets:      Search, Dropdowns: 1 = Infrastructure, 2 = Asset type
            Work:        Search, Dropdowns: 1 = Work entity, 2 = Date range
            NHM:         Search, Dropdowns: 1 = NHM entity, 2 = Date range
            Tutorials:   Search, no dropdowns
        Browser types:   nhm, work, assets, support
        Browser options keys:
            searchText = searchable text in any text field
            category = grouping of tutorials
    */
    import { onMount } from "svelte";
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import browseOpts from "../../Stores/browseOptionsStore.js";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let browserType;
    export let searchText;
    export let optionsSelected;
    export let itemCount;
    let txtFieldSearch;

    onMount(() => {
        txtFieldSearch.addEventListener("keypress", function (event) {
            if (event.key == "Enter") {
                searchButtonClicked();
            } else {
                searchButtonClicked(event.key);
            }
        });
        txtFieldSearch.addEventListener("keydown", function (event) {
            if (event.key === "Backspace") {
                var oldTxtValue = event.currentTarget.value;
                if (oldTxtValue.length > 0) {
                    searchButtonClicked(event.key);
                }
            }
        });
    });

    function searchButtonClicked(keyValue) {
        var sText = txtFieldSearch.value;
        if (keyValue === "Backspace") {
            sText = sText.slice(0, sText.length - 1);
        } else if (keyValue != null) {
            sText = sText + keyValue;
        }
        console.log(sText);
        dispatch("search", {
            searchText: sText,
        });
    }
</script>

<div class="options-view">
    <!-- 1. Search button -->
    <input
        id="txt-browser-search"
        type="text"
        bind:this={txtFieldSearch}
        placeholder={searchText != null ? searchText : "Search table"}
    />
    <button
        id="btn-browser-search"
        on:click={() => searchButtonClicked(null)}
        type="button">Search</button
    >
    <!-- 2. Dropdown 1 -->
    <WPNSelector
        selectorOptions={browseOpts.dropdownOptions(browserType).dd1}
        selectorName="dd1"
        selected={optionsSelected.dd1}
        on:selector-changed
    />
    <!-- 3. Dropdown 2 -->
    {#if optionsSelected.dd2 != undefined}
        <WPNSelector
            selectorOptions={browseOpts.dropdownOptions(browserType).dd2}
            selectorName="dd2"
            selected={optionsSelected.dd2}
            on:selector-changed
        />
    {/if}
    <!-- 4. Item count -->
    <div id="matches-count">
        {"(".concat(itemCount.toString()).concat(")")}
    </div>
</div>

<style>
    .options-view {
        display: flex;
        align-items: center;
        background-color: white;
        padding: 0.5rem 1rem 1rem 1rem;
        margin: auto;
        width: 90%;
        max-height: 6vh;
    }
    #matches-count {
        padding-left: 32px;
    }
    #txt-browser-search {
        margin: 0.25rem 0;
    }
    #btn-browser-search {
        margin: 0 0 0 0;
        background-color: gray;
        color: white;
        border-radius: 4px;
    }
</style>
